
export class CambiarPasswordDTO {
    Password: string = "";
    NewPassword: string = "";
}